export default {
  pt: {
    pageTitle: "Nota fiscal",
    mainTitle: "Qual a chave de acesso da nota fiscal?",
    description: "Digite o código da DANFE.",
    accessKeyLabel: "Chave de acesso",
    invalidKeyTitle: "Chave de acesso inválida!",
    invalidKeyDescription: "Verifique os números e tente novamente.",
    invalidModelTitle: "Chave de acesso inválida!",
    invalidModelDescription: "Esta chave de acesso não é de uma NF-e (modelo 55) ou NFC-e (modelo 65)! Fale com seu bikeshop!",
    danfeTitle: "DANFE - Form Bike",
  },

  en: {
    pageTitle: "Tax invoice",
    mainTitle: "What is the tax invoice access key?",
    description: "Enter the DANFE code.",
    accessKeyLabel: "Access key",
    invalidKeyTitle: "Invalid access key!",
    invalidKeyDescription: "Check the numbers and try again.",
    invalidModelTitle: "Invalid access key!",
    invalidModelDescription: "This access key is not from an NF-e (model 55) or NFC-e (model 65)! Talk to your bikeshop!",
    danfeTitle: "DANFE - Form Bike",
  },
}; 